import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import CityProperty from '../../assets/cityproperty';
import ContractProperty from '../../assets/contractproperty';
import ImagesProperty from '../../assets/imagesproperty';
import { PropertyTabs, Subheader } from "../../components";
import { AuthContext, BackdropContext } from "../../contexts";
import { withNavBars } from "../../HOCs";
import { Routes } from "../../router/routes";
import { accessCheckRender, getRoutePermissionNew, NetWorkCallMethods } from "../../utils";
import { unitStyles } from "./style";
import { Assets, OtherInfo, UnitDetail } from "./tabs";
import { withTranslation } from "react-i18next";
import { NetworkCall } from "../../networkcall";
import { config } from "../../config";
const UnitDetails = ({
    t
}) => {
    const [value, setValue] = React.useState(1);
    const classes = unitStyles()
    const [details, setDetails] = React.useState({
        data: {},
        assets: [],
        asset: []
    })
    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");
    const navigate = useNavigate()
    const backdrop = React.useContext(BackdropContext);
    const auth = React.useContext(AuthContext)
    const [isViewerOpen, setIsViewerOpen] = React.useState(false);
    const [currentImage, setCurrentImage] = React.useState("");
    const [permission, setPermission] = React.useState({})

    React.useEffect(() => {
        const perm = getRoutePermissionNew(auth)
        if (perm) {
            setPermission(perm)
            if (perm?.read) {
                backdrop.setBackDrop({
                    ...backdrop,
                    open: true,
                    message: "",
                });
                getUnitDetails()
            }
        }
        // eslint-disable-next-line
    }, [auth]);

    const openImageViewer = React.useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };


    const getUnitDetails = () => {
        const payload = { unitId: id };

        NetworkCall(
            `${config?.api_url}/queries/unit/get`,
            NetWorkCallMethods.post, payload, null, true, false
        ).then((res) => {
            backdrop.setBackDrop({
                ...backdrop,
                open: false,
                message: "",
            });
            setDetails({
                data: res?.data?.data?.unit[0],
                assets: res?.data?.data?.assets,
                asset: res?.data?.data?.asset,
                shareHolders: res?.data?.data?.share_holder,
                unitContracts: res?.data?.data?.unit_contracts,
                unitProjects: res?.data?.data?.unit_projects,
            })
        })
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const headerpage = [
        {
            id: "1",
            label: details?.data?.block?.name,
            type: "name"
        },
        {
            id: "2",
            label: details?.data?.floor?.name,
            type: "name"
        },
        {
            id: "3",
            label: details?.data?.name,
            type: "name"
        }
    ]
    const tabTittle = [
        {
            label: t("Unit Details"),
            imgSelect: <CityProperty color={value === 1 ? '#5078E1' : '#98A0AC'} />,
            value: 1,
            className: value === 1 ? classes.tabtitle1 : classes.tabtitle,
            selectBack: value === 1 ? classes.selectBack1 : classes.selectBack,
            subtabtitle: value === 1 ? classes.subtabtitle1 : classes.subtabtitle
        },
        {
            label: t("Attachments"),
            imgSelect: <ImagesProperty color={value === 2 ? '#5078E1' : '#98A0AC'} />,
            value: 2,
            className: value === 2 ? classes.tabtitle1 : classes.tabtitle,
            selectBack: value === 2 ? classes.selectBack1 : classes.selectBack,
            subtabtitle: value === 2 ? classes.subtabtitle1 : classes.subtabtitle
        },
        {
            label: t("Related"),
            imgSelect: <ContractProperty color={value === 3 ? '#5078E1' : '#98A0AC'} />,
            value: 3,
            className: value === 3 ? classes.tabtitle1 : classes.tabtitle,
            selectBack: value === 3 ? classes.selectBack1 : classes.selectBack,
            subtabtitle: value === 3 ? classes.subtabtitle1 : classes.subtabtitle
        }
    ]

    const handleedit = () => {
        navigate(Routes.createUnitNew, {
            state: {
                main: {
                    unitID: details?.data?.id,
                    company: details?.data?.unit?.[0]?.property?.company,
                    isEdit: true
                }
            },
        });
    }

    const render = () => {
        return <>
            <Subheader title={details?.data?.property?.name} pageoptions={headerpage} goBack={() => navigate(-1)} />
            <PropertyTabs
                t={t}
                isEdit={permission?.update} value={value} handleChange={handleChange}

                handleedit={handleedit}
                tabTittle={tabTittle}
                showBtns={true}
                tab1={<UnitDetail data={details?.data} assets={details?.asset}
                    closeImageViewer={closeImageViewer}
                    openImageViewer={openImageViewer}
                    isViewerOpen={isViewerOpen}
                    currentImage={currentImage}
                    t={t}
                    shareHolders={details?.shareHolders}
                    unitContracts={details?.unitContracts}
                    unitProjects={details?.unitProjects}
                />}
                tab2={<Assets asset={details?.assets} data={details?.data} />}
                tab3={<OtherInfo    t={t} unitID={id}
                />}
            />
        </>
    }

    return (
        <>
            {accessCheckRender(render, permission)}
        </>
    )
}
const props = {
    boxShadow: false
}
export default withTranslation("unitList")(withNavBars(UnitDetails, props))
